import React from "react";
import { Link } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import { useTranslation } from "react-i18next";

type Props = {
  label: React.ReactNode;
  showHistory: boolean;
  onHistoryClick: () => void;
  marginLeft?: string | number;
};

export default function TaskmapStepHeader({
  label,
  showHistory,
  onHistoryClick,
  marginLeft,
}: Props): React.ReactNode {
  const { t } = useTranslation();
  return (
    <span style={{ display: "flex", gap: "8px", marginLeft }}>
      {label}
      {showHistory ? (
        <Link
          component="button"
          variant="body2"
          onClick={onHistoryClick}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            marginTop: 1,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          <HistoryIcon fontSize="small" />
          {t("link.history")}
        </Link>
      ) : null}
    </span>
  );
}
